import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDepthsAndLocations = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 58,
	viewBox: "0 0 48 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1254_21569)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M47.67 35.71C43.99 35.71 43.99 38.76 40.3 38.76C36.61 38.76 36.62 35.71 32.93 35.71C29.24 35.71 29.25 38.76 25.57 38.76C21.89 38.76 21.89 35.71 18.2 35.71C14.51 35.71 14.52 38.76 10.84 38.76C7.15998 38.76 7.15998 35.71 3.47998 35.71V43.84C7.15998 43.84 7.15998 46.89 10.84 46.89C14.52 46.89 14.52 43.84 18.2 43.84C21.88 43.84 21.88 46.89 25.57 46.89C29.26 46.89 29.25 43.84 32.93 43.84C36.61 43.84 36.61 46.89 40.3 46.89C43.99 46.89 43.98 43.84 47.67 43.84V35.71Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45 56.4199H1V1.41992H35.44L45 11.5199V56.4199Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.66992 15.4199H23.4399",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.66992 21.0498H37.6699",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34 1.41992V12.4199H45",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.669922 31.2998C4.34992 31.2998 4.34992 34.3498 8.02992 34.3498C11.7099 34.3498 11.7099 31.2998 15.3899 31.2998C19.0699 31.2998 19.0699 34.3498 22.7599 34.3498C26.4499 34.3498 26.4399 31.2998 30.1199 31.2998C33.7999 31.2998 33.7999 34.3498 37.4899 34.3498C41.1799 34.3498 41.1699 31.2998 44.8599 31.2998",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.669922 39.4297C4.34992 39.4297 4.34992 42.4797 8.02992 42.4797C11.7099 42.4797 11.7099 39.4297 15.3899 39.4297C19.0699 39.4297 19.0699 42.4797 22.7599 42.4797C26.4499 42.4797 26.4399 39.4297 30.1199 39.4297C33.7999 39.4297 33.7999 42.4797 37.4899 42.4797C41.1799 42.4797 41.1699 39.4297 44.8599 39.4297",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1254_21569",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 47.67,
			height: 57,
			fill: "white",
			transform: "translate(0 0.419922)"
		})
	}) })]
});
export default SvgDepthsAndLocations;
